import axios from 'axios';

/*
 * Calculează starea poliței RCA celei mai recente a userului, pentru cardul
 * adaptiv de pe dashboard. Sursă: `/api/user/asigurari/rca/list` (polițe cumpărate).
 *
 * Sfârșit acoperire = dataPolitaStart + durata (luni). Semnalăm doar când e
 * relevant: expiră curând (≤30 zile) sau a expirat recent (≤90 zile în urmă).
 * Orice eroare de rețea/parsare → întoarce null (cardul pur și simplu nu apare).
 */

export function parseRoDate(str) {
  if (!str || typeof str !== 'string') return null;
  const m = str.match(/(\d{1,2})[-.\/](\d{1,2})[-.\/](\d{4})/);
  if (!m) return null;
  const day = parseInt(m[1], 10);
  const mon = parseInt(m[2], 10);
  const year = parseInt(m[3], 10);
  if (mon < 1 || mon > 12 || day < 1 || day > 31) return null;
  const d = new Date(year, mon - 1, day);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function addMonths(date, months) {
  const d = new Date(date.getTime());
  d.setMonth(d.getMonth() + months);
  return d;
}

export function atMidnight(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

// Doar polițele EMISE au acoperire. Lista din cont conține și comenzi neplătite
// sau în așteptare documente; numărate ca polițe, apăreau drept „expirate".
export function isIssued(policy) {
  return Boolean(policy) && policy.status === 'ISSUED';
}

// Ultima zi de acoperire. API-ul o trimite (`dataPolitaEnd`); calculul din
// start + durata e doar rezerva — iese cu o zi peste (03.11 in loc de 02.11).
export function policyEnd(policy) {
  const end = parseRoDate(policy.dataPolitaEnd);
  if (end) return atMidnight(end);
  const start = parseRoDate(policy.dataPolitaStart);
  const months = parseInt(policy.durata, 10);
  if (!start || !months) return null;
  return atMidnight(addMonths(start, months));
}

export async function getRcaStatus() {
  try {
    const res = await axios({
      method: 'get',
      url: process.env.NEXT_PUBLIC_API + '/api/user/asigurari/rca/list',
      params: { items: 20, page: 1 },
      withCredentials: true,
    });

    const data = res.data;
    if (!data || data.status !== 'success' || !Array.isArray(data.list)) return null;

    let best = null; // polița cu cel mai târziu sfârșit de acoperire
    data.list.forEach((p) => {
      if (!isIssued(p)) return;
      const end = policyEnd(p);
      if (!end) return;
      if (!best || end > best.end) {
        best = { end, provider: p.provider && p.provider.societate_nume };
      }
    });

    if (!best) return null;

    const today = atMidnight(new Date());
    const end = atMidnight(best.end);
    const daysLeft = Math.round((end - today) / 86400000);

    if (daysLeft >= 0 && daysLeft <= 30) {
      return { state: 'expiring', daysLeft, provider: best.provider, endDate: best.end };
    }
    if (daysLeft < 0 && daysLeft >= -90) {
      return { state: 'expired', daysLeft, provider: best.provider, endDate: best.end };
    }
    return null;
  } catch (e) {
    return null;
  }
}
